import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Folder, ChevronRight } from 'lucide-react';

// Components
import Layout from '../components/layout/Layout';
import PageHeader from '../components/ui/PageHeader';
import ParticleBackground from '../components/ui/ParticleBackground';

const Projects = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <PageHeader
        title="Projects"
        subtitle="What we're working on"
        backgroundImage="/images/docs-header.jpg"
      />

      <div className="relative bg-black overflow-hidden min-h-[50vh]">
        <div className="absolute inset-0 z-0 pointer-events-none">
          <ParticleBackground />
        </div>

        <section className="py-20 relative overflow-hidden">
          <div className="container mx-auto px-4 relative z-10">
            <motion.div
              className="max-w-2xl mx-auto text-center p-10 bg-gradient-to-br from-gray-900/80 to-black/80 border border-gray-700/30 rounded-2xl backdrop-blur-sm"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <Folder size={40} className="mx-auto mb-6 text-gray-500" />
              <p className="text-gray-400 text-lg mb-8">
                Project information available upon request.
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-gray-600 to-gray-800 hover:from-gray-500 hover:to-gray-700 text-white font-semibold rounded-xl transition-all duration-500"
              >
                Contact Us
                <ChevronRight className="ml-2" size={18} />
              </Link>
            </motion.div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default Projects;
